import type { FC } from 'react'

export const Badge: FC<{ title?: string | null; className?: string }> = ({
  title,
  className,
}) => (
  <>
    {title && (
      <span
        className={`rounded bg-serblue-light px-2.5 py-0.5 font-medium text-white ${
          className ?? ''
        }`}
      >
        {title}
      </span>
    )}
  </>
)
